module.exports = "images/12ans.f0b7b594.png";